import { render, staticRenderFns } from "./SaveConflictModal.vue?vue&type=template&id=7dbf36c2&scoped=true"
import script from "./SaveConflictModal.vue?vue&type=script&lang=js"
export * from "./SaveConflictModal.vue?vue&type=script&lang=js"
import style0 from "./SaveConflictModal.vue?vue&type=style&index=0&id=7dbf36c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbf36c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dbf36c2')) {
      api.createRecord('7dbf36c2', component.options)
    } else {
      api.reload('7dbf36c2', component.options)
    }
    module.hot.accept("./SaveConflictModal.vue?vue&type=template&id=7dbf36c2&scoped=true", function () {
      api.rerender('7dbf36c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaModal/SaveConflictModal.vue"
export default component.exports